var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.625C0 0.28125 0.28125 0 0.625 0L3.125 0L5 1.875L5 5.625C5 5.96875 4.71875 6.25 4.375 6.25L0.625 6.25C0.28125 6.25 0 5.96875 0 5.625L0 0.625ZM2.83379 1.40215L2.80303 0.75L0.532812 0.75L0.5 1.40215L0.57793 1.40215C0.5875 1.27637 0.617578 1.17656 0.668164 1.10273C0.71875 1.02891 0.77959 0.979004 0.850684 0.953027Q0.932715 0.924316 1.12754 0.924316L1.46182 0.924316L1.46182 3.04893Q1.46182 3.28271 1.4167 3.34834Q1.34287 3.45498 1.1665 3.45498L1.06807 3.45498L1.06807 3.53086L2.24727 3.53086L2.24727 3.45498L2.15088 3.45498Q1.98887 3.45498 1.91094 3.36885Q1.85557 3.30527 1.85557 3.04893L1.85557 0.924316L2.24727 0.924316Q2.41953 0.924317 2.52515 0.980713Q2.63076 1.03711 2.69434 1.15605C2.72031 1.20527 2.74082 1.2873 2.75586 1.40215L2.83379 1.40215ZM0.588242 4.46431L4.41177 4.46431L4.41177 4.16669L0.588242 4.16669L0.588242 4.46431ZM4.26471 5.35713L0.588242 5.35713L0.588242 5.05951L4.41177 5.05951L4.41177 5.35713L4.26471 5.35713Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(0.5999756 0.60009766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 0L12 12L0 12L0 0Z",
    id: "Background",
    fill: "#B1BAC1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.5 2.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.625C0 0.28125 0.28125 0 0.625 0L3.125 0L5 1.875L5 5.625C5 5.96875 4.71875 6.25 4.375 6.25L0.625 6.25C0.28125 6.25 0 5.96875 0 5.625L0 0.625ZM2.83379 1.40215L2.80303 0.75L0.532812 0.75L0.5 1.40215L0.57793 1.40215C0.5875 1.27637 0.617578 1.17656 0.668164 1.10273C0.71875 1.02891 0.77959 0.979004 0.850684 0.953027Q0.932715 0.924316 1.12754 0.924316L1.46182 0.924316L1.46182 3.04893Q1.46182 3.28271 1.4167 3.34834Q1.34287 3.45498 1.1665 3.45498L1.06807 3.45498L1.06807 3.53086L2.24727 3.53086L2.24727 3.45498L2.15088 3.45498Q1.98887 3.45498 1.91094 3.36885Q1.85557 3.30527 1.85557 3.04893L1.85557 0.924316L2.24727 0.924316Q2.41953 0.924317 2.52515 0.980713Q2.63076 1.03711 2.69434 1.15605C2.72031 1.20527 2.74082 1.2873 2.75586 1.40215L2.83379 1.40215ZM0.588242 4.46431L4.41177 4.46431L4.41177 4.16669L0.588242 4.16669L0.588242 4.46431ZM4.26471 5.35713L0.588242 5.35713L0.588242 5.05951L4.41177 5.05951L4.41177 5.35713L4.26471 5.35713Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.4c5923e923f0e8d2d4eaff7c9392b776.svg";
export { ForwardRef as ReactComponent };